<template src="./Videoplayer.html"></template>
<style scoped src="./Videoplayer.scss" lang="scss"></style>
<script>
import videojs from "video.js";
import { mapGetters, mapActions } from "vuex";
import ScrollHelper from "@/utils/ScrollHelper";
import moment from "moment";
moment.locale("es");

let __scroll = new ScrollHelper();

export default {
  props: {
    urlVideo: String
  },
  data: function() {
    return {
      playVideo: false
    };
  },
  computed: {
    ...mapGetters(["videoCinemaActiveItem", "videoCinemaPreviewItem"]),
    postTimeAgo: function() {
      let aDate = this.videoCinemaActiveItem.date.split("-");
      var a = moment([aDate[2], aDate[1], aDate[0]]);
      var b = moment();
      return a.from(b);
    }
  },
  watch: {
    playVideo: function(newValue, oldValue){
      //si pasa a ejecutarse play directo al video
      if(!oldValue && newValue)this.player.play();
    }
  },
  methods: {
    ...mapActions(["activeVideoCinema"]),
    close(){
      this.activeVideoCinema({activo:false});
    },
    getAuthor() {
      return this.$store.getters.getAuthorById(parseInt(this.videoCinemaActiveItem.author));
    },
    playFromPreview() {
      this.playVideo = true;
    }
  },
  mounted() {
    let needAutoplay =  !this.videoCinemaPreviewItem;

    //mp4
    if ( this.$refs.videoPlayer )
    {
      this.player = videojs(
        this.$refs.videoPlayer,
        {
          controls: true,
          autoplay: needAutoplay,
          sources: [
            {
              src: this.videoCinemaActiveItem.url_video,
              type: "video/mp4"
            }
          ]
        },
        function onPlayerReady() {
          // console.log("onPlayerReady", this);
        }
      );
    }


  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  destroyed() {
    this.playVideo = false;
    //desbloquea scroll
    __scroll.lock(false);
  }
};
</script>
